var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "AssetLocation" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("get.assetLocation.general"),
                    active: !_vm.developmentMode
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LocationId",
                            error: _vm.$v.form.LocationId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.assetLocations,
                              searchable: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "LocationId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.location,
                              callback: function($$v) {
                                _vm.location = $$v
                              },
                              expression: "location"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LastMovementDate",
                            error: _vm.$v.form.LastMovementDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.LastMovementDate
                            },
                            model: {
                              value: _vm.form.LastMovementDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LastMovementDate", $$v)
                              },
                              expression: "form.LastMovementDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AssetId",
                            error: _vm.$v.form.AssetId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { url: "VisionNextAsset/api/Asset/Search" },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType("AssetId", $event)
                              }
                            },
                            model: {
                              value: _vm.asset,
                              callback: function($$v) {
                                _vm.asset = $$v
                              },
                              expression: "asset"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LastOperationDate",
                            error: _vm.$v.form.LastOperationDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.LastOperationDate
                            },
                            model: {
                              value: _vm.form.LastOperationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LastOperationDate", $$v)
                              },
                              expression: "form.LastOperationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ConditionId",
                            error: _vm.$v.form.ConditionId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "ASSET_CONDITION" },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("ConditionId", $event)
                              }
                            },
                            model: {
                              value: _vm.condition,
                              callback: function($$v) {
                                _vm.condition = $$v
                              },
                              expression: "condition"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "StateId",
                            error: _vm.$v.form.StateId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextAsset/api/AssetState/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType("StateId", $event)
                              }
                            },
                            model: {
                              value: _vm.state,
                              callback: function($$v) {
                                _vm.state = $$v
                              },
                              expression: "state"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SerialNumber",
                            error: _vm.$v.form.SerialNumber
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.SerialNumber
                            },
                            model: {
                              value: _vm.form.SerialNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SerialNumber", $$v)
                              },
                              expression: "form.SerialNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ContactId",
                            error: _vm.$v.form.ContactId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { url: "" },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ContactId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.contact,
                              callback: function($$v) {
                                _vm.contact = $$v
                              },
                              expression: "contact"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AssetPositionId",
                            error: _vm.$v.form.AssetPositionId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "ASSET_POSITION" },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AssetPositionId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.assetPosition,
                              callback: function($$v) {
                                _vm.assetPosition = $$v
                              },
                              expression: "assetPosition"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Quantity",
                            error: _vm.$v.form.Quantity
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Quantity
                            },
                            model: {
                              value: _vm.form.Quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Quantity", $$v)
                              },
                              expression: "form.Quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SerialNumber2",
                            error: _vm.$v.form.SerialNumber2
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.SerialNumber2
                            },
                            model: {
                              value: _vm.form.SerialNumber2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SerialNumber2", $$v)
                              },
                              expression: "form.SerialNumber2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5db7e877", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db7e877","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AssetLocation/update.vue
// module id = null
// module chunks = 